import api from './api';

export default {
  async crear(payload: any) {
    return api.post('acompanamiento/', payload);
  },
  async listar(params?: { ps_codigo?: string; limit?: number; offset?: number }) {
    const q = new URLSearchParams();
    if (params?.ps_codigo) q.append('ps_codigo', params.ps_codigo);
    if (params?.limit != null) q.append('limit', String(params.limit));
    if (params?.offset != null) q.append('offset', String(params.offset));
    const qs = q.toString();
    return api.get(`acompanamiento/${qs ? `?${qs}` : ''}`);
  },
  async detalle(id: number) {
    return api.get(`acompanamiento/${id}`);
  },
};
